import { useContext } from "react";
import { FeatureFlagContext } from "../contexts/FeatureFlagContext";

export const useFeatureFlag = (flagNameOrNames) => {
  const { flags, isLoading, isEnabled, isDisabled } = useContext(FeatureFlagContext);
  
  if (typeof flagNameOrNames === "string") {
    return {
      isEnabled: isEnabled(flagNameOrNames),
      isDisabled: isDisabled(flagNameOrNames),
      isLoading,
      value: flags[flagNameOrNames],
    };
  }
  
  if (Array.isArray(flagNameOrNames)) {
    const result = {};
    flagNameOrNames.forEach((name) => {
      result[name] = {
        isEnabled: isEnabled(name),
        isDisabled: isDisabled(name),
        value: flags[name],
      };
    });
    return {
      ...result,
      isLoading,
    };
  }
  
  throw new Error("useFeatureFlag expects a string or array of strings");
};
